const Footer = () => {
	return (
		<footer className="sticky-footer bg-white mt-4">
			<div className="container my-auto">
				<div className="copyright text-center my-auto">
					<span style={{ fontStyle: "italic" }}>
						<a href="https://lapage.vn" target="_blank" rel="noreferrer">
							LaPage.vn
						</a>{" "}
						- Thiết Kế Website Chuyên Nghiệp
					</span>
				</div>
			</div>
		</footer>
	);
};

export default Footer;
